import { render, staticRenderFns } from "./DashboardLogistics.vue?vue&type=template&id=0ee3bbc0"
import script from "./DashboardLogistics.vue?vue&type=script&lang=js"
export * from "./DashboardLogistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports